import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    laboratorySamplesSubmittedTo: Yup.string().nullable().required("Laboratory samples submitted to is required"),
    submittedBy: Yup.string().nullable().required("Submitted by is required")
});